import { useMemo } from 'react'
import { Platform, StyleSheet } from 'react-native'

import { useTheme } from 'styled-components/native'

import { ThemeType } from '../utils/themes/ThemeProvider'

/**
 * Hook that returns floating card styles with theme awareness.
 * Automatically handles Aurora theme by removing shadows.
 */
export const useFloatingStyles = (options?: {
  interactive?: boolean
  hovered?: boolean
  pressed?: boolean
  simpleBoxShadow?: boolean
  initialHiddenBoxShadow?: boolean
}) => {
  const { componentStyles } = useTheme() as ThemeType
  const { interactive, hovered, pressed, simpleBoxShadow = false, initialHiddenBoxShadow = false } = options || {}

  return useMemo(() => {
    if (!componentStyles.useFloatingCardsShadows) {
      return StyleSheet.create({
        floatingCard: {},
      })
    }

    return StyleSheet.create({
      floatingCard: {
        ...Platform.select({
          ios: {
            shadowColor: '#000',
            shadowOpacity: 0.1,
            shadowOffset: { width: 0, height: 4 },
            shadowRadius: 5,
          },
          android: {
            elevation: 5,
          },
          web: {
            boxShadow: initialHiddenBoxShadow
              ? 'none'
              : simpleBoxShadow
              ? '0px 2px 10px 0px rgba(0, 0, 0, 0.12)'
              : '0px 3px 6px 0px rgba(0, 0, 0, 0.16), 0px 2px 4px 1px rgba(0, 0, 0, 0.08)',
            ...(interactive && { transition: 'all 0.15s ease-out' }),
            ...(hovered &&
              !pressed && {
                boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.16), 0px 4px 8px 2px rgba(0, 0, 0, 0.08)',
              }),
            ...(pressed && {
              boxShadow: 'none',
            }),
          },
        }),
      },
    })
  }, [interactive, hovered, pressed, simpleBoxShadow, initialHiddenBoxShadow, componentStyles.useFloatingCardsShadows])
}
